import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';
import Util from '../../libs/util/Util';

/**
 * 古いブラウザの警告 クラス
 */
export default class DepricatedTerminalClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'DepricatedTerminalClass';

    this.target = _target;
  }

  onCreate() {
    super.onCreate();

    const userAgent = window.navigator.userAgent.toLowerCase();

    /** @var {bool} IE11以上か */
    var ieVersion = window.navigator.appVersion.toLowerCase();
    var isIE11    = ieVersion.indexOf("msie 11.") !== -1 || userAgent.indexOf('trident/7') !== -1;
    
    // @var {bool} IOS(IPhone, Ipod)でバージョン10以上か */
    var isIPhone = false;
    if(userAgent.indexOf("iphone") !== -1 || userAgent.indexOf("ipod") !== -1 || userAgent.indexOf("ipad") !== -1) {
      // バージョンを取得
      var version = userAgent.split('os ')[1].split(' ')[0];
      // 枝番がある場合
      if (version.indexOf('_') >= 0){
        // メジャーバージョンのみ取得
         version = parseInt(version.split('_')[0]);
      }
      if(version >= 10) {
        isIPhone = true;
      }
	}
    
    // @var {bool} Androidでバージョン6以上か */
    var isAndroid = false;
    if(userAgent.indexOf("android") !== -1) {
      var andVersion = parseFloat(userAgent.slice(userAgent.indexOf("android")+8));
      if(andVersion >= 6) {
        isAndroid = true;
      }
    }
    
    // @var {bool} FirefoxでWindows7以上か */
    var isFirefox = false;
    if(userAgent.indexOf("firefox") !== -1) {
      // Windows 10
      if (userAgent.match(/win(dows )?nt 10\./)) {
        isFirefox = true;
      // Windows 8.1
      } else if (userAgent.match(/win(dows )?nt 6\.3/)) {
        isFirefox = true;
      // Windows 8
      } else if (userAgent.match(/win(dows )?nt 6\.2/)) {
        isFirefox = true;
      // Windows 7
      } else if (userAgent.match(/win(dows )?nt 6\.1/)) {
        isFirefox = true;
      }
    }
    
    // @var {bool} ChromeでWindows7以上か */
    var isChrome = false;
    if(userAgent.indexOf("chrome") !== -1 && userAgent.indexOf("opr") == -1 && userAgent.indexOf("opera") == -1 )    {
      // Windows 10
      if (userAgent.match(/win(dows )?nt 10\./)) {
        isChrome = true;
      // Windows 8.1
      } else if (userAgent.match(/win(dows )?nt 6\.3/)) {
        isChrome = true;
      // Windows 8
      } else if (userAgent.match(/win(dows )?nt 6\.2/)) {
        isChrome = true;
      // Windows 7
      } else if (userAgent.match(/win(dows )?nt 6\.1/)) {
        isChrome = true;
      }
    }
    
    // @var {bool} Mac10以上か */
    var isMacOs = false;
    if(userAgent.indexOf("mac") != -1){ 
      var osVersion = userAgent.split('os ')[1].split(' ')[1];
      // 枝番がある場合
      if (osVersion.indexOf('_') >= 0){
        // メジャーバージョンのみ取得
         osVersion = parseInt(osVersion.split('_')[0]);
      }
      if(osVersion >= 10) {
        isMacOs = true;
      }
    }

    if (!(isIE11 || isMacOs || isChrome ||  isFirefox || isIPhone || isAndroid)) {
      /** @var {string} 古いブラウザのときに表示するHTML */
      const HTML = `
    <div class="wrap_contents w1232">
      <div class="deprecated_terminal">
        <p>本サイトは、お使いの環境に対応しておりません。</p>
        <p>下記の動作推奨環境をご確認ください。</p>
        <p> ＜スマートフォン＞<br> OS：iOS 10以上、Andoroid 6.0以上<br>
          ブラウザ：Safari最新版、Google Chrome最新版 </p>
        <p> ＜パソコン＞<br> OS：Windows7以上、MacOS X 10.8以上<br>
          ブラウザ：Internet Explorer11.0以上、Edge最新版、Fire fox最新版、Google Chrome最新版 </p>
      </div><!-- /deprecated_terminal -->
    </div><!-- /wrap_contents -->`;

      // DOMに流し込み
      // 通常の検索画面の場合
      $('.wrap_breadcrumb').after(HTML);
      // 決済画面の場合
      $('.wrap_input_step').parent().before(HTML);
      // お知らせ系
      $('.wrap_information').html(HTML);
    }
  }
}
